/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCartFlatbedContainer: {
  name: 'cart-flatbed-container';
  data: string;
} = {
  name: 'cart-flatbed-container',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v10c1.48 0 2.773.804 3.465 2H19a1 1 0 1 1 0 2h-7a4 4 0 1 1-6-3.465V4H5a1 1 0 0 1-1-1Zm6 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5Zm2 3v4h3l-3-4Zm1-2 3 4V6h-3ZM8 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" fill="currentColor"/></svg>`,
};
